var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { EventCategory, trackEvent } from '@lendi/analytics';
import { ChatEventName } from '../analytics/types';
export var analytics = function (navbarAnalyticsEvent) {
    if (window && window.analytics) {
        trackEvent(__assign({}, navbarAnalyticsEvent));
    }
    else {
        if (process.env.NODE_ENV === 'development') {
            // gives us the indication of what events are being fired
            // eslint-disable-next-line no-console
            console.log('event', __assign({}, navbarAnalyticsEvent));
        }
        else {
            // eslint-disable-next-line no-console
            console.error('@lendi/analytics is not loaded');
        }
    }
};
export var useEmailOpenChat = function (openChatWindow, channelId) {
    var hasWindow = typeof window !== 'undefined';
    React.useEffect(function () {
        if (hasWindow) {
            var queryData = new URLSearchParams(window.location.search);
            var shouldOpenChatWindow = queryData.get('openChatWindow');
            if (shouldOpenChatWindow) {
                openChatWindow();
                var event_1 = {
                    event_name: ChatEventName.CHAT_OPENED_FROM_EXTERNAL,
                    text: 'Chat Opened From Email',
                    linkType: 'Opened From Email',
                    category: EventCategory.NAVBAR,
                };
                analytics(event_1);
            }
        }
    }, []);
};
//# sourceMappingURL=useEmailOpenChat.js.map